// extracted by mini-css-extract-plugin
export var legendIndicator = "_dg-1";
export var legendRight = "_dg-0";